export default {
  loadFailed: "Неуспешно вчитување на тестовите. Проверете ја врската и обидете се повторно.",
  page_header: {
    title: "Тестови",
    description: "Управување со лабораториски тест дефиниции, мапирања и процесори.",
  },

  toolbar: {
    refresh: "Освежи тестови",
  },

  table: {
    search_placeholder: "Пребарувај тестови...",
    new_test: "Додавање на тест",
    columns: {
      instrument: "Апарат",
      name: "Име на тест",
      test_code: "Код / Синоним",
      test_code_tooltip:
        "Кодот испратен од апаратот за идентификација на аналитот (нпр. 'GLU', 'HGB'). Резултатите со непознат код се отфрлаат.",
      modifier: "Модификатор",
      modifier_tooltip:
        "Дополнителен разграничувач кога истиот тест код произведува повеќе типови резултати (нпр. 'CONC' наспрема 'INTERP'). Оставете празно за тестови со еден тип резултат. Се користи само во извештаи за резултати, не во нарачки.",
      direction: "Насока",
      direction_tooltip:
        "Контролира како Iris ги насочува податоците: Двонасочен (нарачки и резултати), Само нарачки (испраќа нарачки, ги отфрла резултатите) или Само резултати (прима резултати, никогаш не испраќа нарачки).",
      result_type: "Тип",
      result_type_tooltip:
        "Форматот на вредноста на резултатот произведена од тестот: нумерички, текстуален, квалитативен (набројан) и сл.",
      scale: "Децимални места",
      scale_tooltip: "Број на децимални места при прикажување на нумерички резултати за тестот.",
      status: "Статус",
      created_time: "Датум / Час",
      created_time_tooltip: "Датумот и времето кога е создаден тестот.",
      actions: "Акции",
    },
    empty: {
      title: "Нема достапни тестови",
      description: "Сè уште нема конфигурирани тест дефиниции.",
    },
    no_results: "Нема тестови што одговараат на '{query}'",
    status_enabled: "Активен",
    status_disabled: "Деактивиран",
    collapse_group: "Собери група",
    expand_group: "Рашири група",
    actions: {
      edit: "Уредување на тест",
      delete: "Бришење на тест",
    },
  },

  editor: {
    title_create: "Додавање на тест",
    title_edit: "Уредување на тест",
    subtitle_create: "Конфигурирање на нова тест дефиниција за избраниот апарат",
    subtitle_instrument: "Апарат",
    subtitle_test: "Тест",
    add: "Додавање тест",
    save: "Зачувување промени",
    reset: "Воспоставување",
    cancel: "Откажување",

    tabs: {
      basic_data: "Основни податоци",
      mappings: "LIS соодветствија",
      processors: "Процесори",
    },

    fields: {
      instrument: "Апарат",
      name: "Име на тест",
      test_code: "Код",
      modifier: "Модификатор",
      direction: "Насока",
      result_type: "Тип резултат",
      scale: "Децимални места",
      is_filter: "Филтер тест",
      is_filter_on_title: "Филтрира резултати",
      is_filter_off_title: "Не филтрира резултати",
      is_disabled: "Деактивиран",
      is_disabled_on_title: "Тестот е деактивиран",
      is_disabled_off_title: "Тестот е активен",
      activate: "Активирање",
      deactivate: "Деактивирање",
      modifier_placeholder: "пр. STAT",
      scale_placeholder: "пр. 2",
    },

    hints: {
      instrument: "Апаратот со кој е поврзан овој тест.",
      name: "Човечки-читливо име за оваа тест дефиниција.",
      test_code: "Код на показателот од апаратот.",
      modifier: "Дополнителен модификатор за разликување варијанти на ист тест код. нпр.: синоним*модификатор",
      direction: "Дали тестот само се нарачува, изработува или и двете.",
      result_type: "Типот на податок на вредноста на резултатот: квантитативен, текстуален или друг.",
      scale: "Број на цифри по децимална точка.",
      is_filter_on: "Резултатите со овој тест ќе бидат задржани за филтрирање",
      is_filter_off: "Резултатите со овој тест немаат да минат преку филтрирање",
      is_disabled_on: "Тестот нема да прифаќа нови нарачки или резултати",
      is_disabled_off: "Тестот прифаќа нарачки и резултати нормално",
    },

    validation: {
      test_code_required: "Тест кодот е задолжителен",
      name_required: "Името на тестот е задолжително",
      test_code_max_length: "Тест кодот мора да е до 50 карактери",
      test_code_duplicate: "Веќе постои тест со овој код за овој апарат",
      name_max_length: "Името мора да е до 255 карактери",
      modifier_max_length: "Модификаторот мора да е до 50 карактери",
      scale_min: "Скалата мора да е најмалку 0",
      scale_max: "Скалата мора да е најмногу 10",
    },
  },

  directions: {
    bidirectional: "Двонасочен",
    orders_only: "Само нарачки",
    results_only: "Само резултати",
  },

  result_types: {
    quantitative: "Квантитативен",
    semiquantitative: "Полуквантитативен",
    qualitative: "Квалитативен",
    text: "Текстуален",
    ratio: "Однос",
    predefined_list: "Предефинирана листа",
    arbitrary: "Произволен",
    antibiotic_susceptibility: "Антибиотска чувствителност",
    image: "Слика",
  },

  direction_hints: {
    bidirectional: "Нарачки и резултати — се користи и за нарачување и за примање резултати",
    results_only: "Само резултати — никогаш не се испраќа како нарачка до апаратот",
    orders_only: "Само нарачки — никогаш не враќа резултати",
  },

  result_type_hints: {
    quantitative: "Квантитативен резултат — нумеричка вредност, нпр. 3, 4.5",
    semiquantitative: "Полуквантитативен резултат — степени, нивоа или опсеги",
    qualitative: "Квалитативен резултат — Позитивен, Негативен, Сива зона",
    text: 'Текстуален резултат — слободен текст, нпр. "Црвено", "Бледо"',
    ratio: "Резултат како однос, нпр. 1:2, 1:4",
    predefined_list: "Резултат од предефинирана леста на вредности",
    arbitrary: 'Произволен резултат — симболи или ознаки, нпр. "+", "2+", "-"',
    antibiotic_susceptibility: "Антибиотска чувствителност — нпр. S, I, R",
    image: "Слика — бинарни податоци",
  },
  mappings: {
    title: "Мапирања",
    add: "Додавање на мапирање",
    edit: "Уредување на мапирање",
    done: "Готово",
    columns: {
      mapping_key: "Тест ID",
      lis_name: "LIS име",
      created_time: "Датум / Час",
      actions: "Акции",
    },
    add_subtitle: "Конфигурирајте ново мапирање за овој тест.",
    subtitle_test: "Код на тест",
    subtitle_id: "ID на тест",
    subtitle_created: "Создаден",
    subtitle_lis_id: "LIS ID",
    subtitle_test_code_tooltip: "Код на тестот за LIS нарачки",
    subtitle_id_tooltip: "Системски идентификатор на родителскиот тест",
    subtitle_lis_id_tooltip: "LIS клуч за насочување на резултатите",
    subtitle_created_tooltip: "Датум на создавање на соодветствието",
    date_created: "Креирано",
    date_modified: "Последно изменето",
    hints: {
      mapping_key: "Уникатниот ИД со кој апаратот го идентификува тестот.",
      lis_name: "Приказното име кое LIS системот го користи за тестот.",
    },
    empty: "Нема дефинирани мапирања",
    delete_confirm: {
      title: "Отстранување на мапирање",
      message: "Ова мапирање ќе биде отстрането. Промената се применува при зачувување на тестот.",
    },
    validation: {
      mapping_key_required: "Тест ID е задолжителен",
      mapping_key_too_long: "Тест ID мора да биде 100 знаци или помалку",
      mapping_key_duplicate: "Веќе постои мапирање со овој клуч",
      lis_name_required: "LIS името е задолжително",
      lis_name_too_long: "LIS името мора да биде 255 знаци или помалку",
    },
    unsaved_dialog_title: "Незачувани промени",
    unsaved_save_and_leave: "Зачувување и продолжување",
    unsaved_discard: "Отфрлање",
    unsaved_stay: "Останување",
  },

  processors: {
    title: "Процесори",
    add: "Додавање на процесор",
    edit: "Уредување на процесор",
    done: "Готово",
    columns: {
      rank: "Позиција",
      active: "Активен",
      status: "Статус",
      content: "Формула",
      created_time: "Датум / Час",
      actions: "Акции",
    },
    status_active: "Активен",
    status_inactive: "Неактивен",
    add_subtitle: "Конфигурирајте нов процесор за овој тест.",
    subtitle_rank_tooltip: "Ред на извршување — помал ранг се извршува прво",
    subtitle_type_tooltip: "Тип процесор (скриптен, нумерички или текстуален)",
    subtitle_status_tooltip: "Дали процесорот се извршува при обработка на резултати",
    date_created: "Креирано",
    date_modified: "Последно изменето",
    hints: {
      rank: "Редослед на извршување — пониската позиција се извршува прва.",
      active: "Кога е деактивиран, процесорот се прескокнува при обработката.",
      active_on: "Процесорот е активен и ќе учествува во обработката на резултати",
      active_off: "Процесорот е деактивиран и ќе биде прескокнат при обработката",
      content: "JavaScript израз кој се евалуира врз основа на резултатниот објект.",
    },
    empty: "Нема дефинирани процесори",
    delete_confirm: {
      title: "Отстранување на процесор",
      message: "Овој процесор ќе биде отстранет. Промената се применува при зачувување на тестот.",
    },
    validation: {
      rank_min: "Позицијата мора да биде најмалу 1",
      rank_duplicate: "Веќе постои процесор со ова позиција",
      then_action_required: "Додајте барем едно дејство во 'Тогаш'",
      then_text_value_required: "Текстуалната вредност е задолжителна",
    },
    unsaved_dialog_title: "Незачувани промени",
    unsaved_save_and_leave: "Зачувување и продолжување",
    unsaved_discard: "Отфрлање",
    unsaved_stay: "Останување",
    types: {
      js: "JavaScript скрипта",
      num: "Нумерички услови",
      txt: "Текстуални услови",
    },
    type_label: "Тип процесор",
    type_hint: "Изберете тип на логика за обработка за овој процесор.",
    script_label: "Скрипта (JavaScript)",
    when_label: "Кога",
    then_label: "Тогаш",
    comparison_label: "Споредба",
    value_label: "Вредност",
    value2_label: "До",
    then_text_value_label: "Текстуална вредност",
    then_numeric_prefix_label: "Нумерички префикс",
    then_numeric_value_label: "Нумеричка вредност",
    then_to_be_filtered_label: "Филтрирање од LIS",
    then_to_be_filtered_hint:
      "Кога условото е исполнето, резултатот ќе биде задржан за филтрирање и нема да достигне до LIS",
    then_to_be_filtered_on_title: "Филтриран — не достигнува до LIS",
    then_to_be_filtered_off_title: "Не филтриран — се испраќа кон LIS",
    then_to_be_filtered_on_hint:
      "Кога условото е исполнето, резултатот ќе биде задржан за филтрирање и нема да достигне до LIS",
    then_to_be_filtered_off_hint: "Резултатот ќе биде испратен кон LIS нормално",
    then_text_value_hint: "Ја заменува текстуалната ознака прикажана за овој резултат",
    then_numeric_prefix_hint: "Префикс прикажан пред нумеричката вредност, пр. '>' или '<'",
    then_numeric_value_hint: "Ја заменува нумеричката вредност зачувана за овој резултат",
    flags_label: "Знамиња",
    flags_hint: "Знамињата се прикачуваат кон резултатот при исполнување на условот",
    add_flag: "Додавање знаме",
    no_flags: "Нема дефинирани знамиња",
    flag_number: "Знаме {n}",
    flag_code_label: "Код на знаме",
    flag_value_label: "Опис на знаме",
    flag_level_label: "Ниво на знаме",
    when_values_label: "Вредности за совпаѓање",
    add_when_value: "Додавање вредност",
    no_when_values: "Нема дефинирани вредности за совпаѓање",
    when_value_number: "Вредност {n}",
    js_name_label: "Назив на процесорот",
    js_name_hint: "Незадолжителна читлива ознака за скрипт процесорот",
    when_exclusive_hint: "Помало и поголемо се ексклузивни — граничната вредност не се вклучува",
    when_between_hint: "Помеѓу е инклузивно — граничните вредности се вклучуваат",
    txt_when_hint: "Внесете вредност и притиснете Enter или кликнете + за да ја додадете",
    txt_isnull_hint: "Се применува кога текстуалниот резултат е празен или null",
    comparisons: {
      less_than: "Помало од",
      equal: "Еднакво на",
      greater_than: "Поголемо од",
      is_null: "Е празно",
      between: "Помеѓу",
      contains: "Содржи",
      starts_with: "Започнува со",
      ends_with: "Завршува со",
    },
    flag_levels: {
      info: "Информација",
      warning: "Предупредување",
      error: "Грешка",
      critical: "Критично",
    },
    summary: {
      filtered: "филтриран од LIS",
      prefix: "префикс",
      flag: "знаме",
      js_script: "JS скрипта",
    },
    preview: {
      value_var: "вредност",
      text_var: "текст",
    },
  },

  delete_dialog: {
    title: "Потврдување на бришење",
    subtitle: "На пат сте да го избришете тестот: {name}",
    subtitle_test: "Тест",
    subtitle_id: "ID на тест",
    subtitle_name_tooltip: "Прикажано назив на тестот",
    subtitle_id_tooltip: "Системски идентификатор на тестот",
    warning: "Тестот и сите поврзани податоци ќе бидат трајно избришани.",
    has_related_items:
      "Тестот не може да се избрише бидејќи има поврзани соодветствија или правила за обработка. Ве молиме прво отстранете ги од соодветните јазичиња.",
    confirm: "Бришење на тест",
    cancel: "Откажување",
  },

  snackbar: {
    create_success: "Тестот е успешно креиран",
    update_success: "Тестот е успешно ажуриран",

    delete_success: "Тестот е успешно избришан",
    create_failed: "Неуспешно креирање на тест",
    update_failed: "Неуспешно ажурирање на тест",
    delete_failed: "Неуспешно бришење на тест",
    fetch_failed: "Неуспешно вчитување на тестови",
    mapping_added: "Соодветствието е додадено",
    mapping_updated: "Соодветствието е ажурирано",
    mapping_removed: "Соодветствието е отстрането",
    mapping_add_failed: "Неуспешно додавање на соодветствие",
    mapping_remove_failed: "Неуспешно отстранување на соодветствие",
    processor_added: "Процесорот е додаден",
    processor_updated: "Процесорот е ажуриран",
    processor_removed: "Процесорот е отстранет",
    processor_add_failed: "Неуспешно додавање на процесор",
    processor_remove_failed: "Неуспешно отстранување на процесор",
    reset_success: "Основните податоци се воспоставени",
  },
};
